import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ProductAvailabilityLabel from 'src/components/productAvailabilityLabel';
import RootStore from 'src/stores/RootStore';
import { TProductModel } from 'src/stores/types/ProductTypes';
import { DEFAULT_BREKR_CARRIER_CODES } from 'src/utils/constants';

interface SelectCarrierProps {
    store?: typeof RootStore.Type;
    selectedCarrierCode: string;
    setSelectedCarrierCode: (selected: string) => void;
}

const SelectCarrier = inject('store')(
    observer(({ store, selectedCarrierCode, setSelectedCarrierCode }: SelectCarrierProps) => {
        const carrierList: TProductModel[] | [] = store?.products.carrierList;
        const [isOpen, setOpen] = useState(false);

        useEffect(() => {
            if (carrierList?.length) {
                const defaultValue = carrierList.find(
                    part =>
                        (DEFAULT_BREKR_CARRIER_CODES.has(part.id) && part.productInformation.inStock) ??
                        part.productInformation.inStock,
                );
                if (defaultValue) {
                    setSelectedCarrierCode(defaultValue.id);
                } else {
                    setSelectedCarrierCode('empty');
                }
            }
        }, [carrierList]);

        if (!carrierList?.length) {
            return null;
        }

        const getOption = (value: string) => {
            const foundOption = carrierList.find(part => part.id === value);
            return foundOption ? foundOption.productInformation.name : <></>;
        };

        return (
            <FormControl variant="standard" sx={{ margin: '10px 0 10px', width: '100%' }}>
                <InputLabel htmlFor="brekr-carrier-item">
                    <FormattedMessage id="select.carrier" />
                </InputLabel>
                <Select
                    data-testid="carriersSelector"
                    labelId="brekr-carrier-item"
                    open={isOpen}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    value={selectedCarrierCode}
                    name="selectedCarriersColor"
                    displayEmpty={false}
                    renderValue={(value: any) => getOption(value)}
                    onChange={e => setSelectedCarrierCode(e.target.value as string)}
                    sx={{ overflow: 'hidden' }}
                >
                    {carrierList.map((part: TProductModel) => (
                        <MenuItem
                            key={part.id}
                            value={part.id}
                            data-testid={`brekr-carrier-${part.id}`}
                            style={{ display: 'flex', justifyContent: 'space-between' }}
                            disabled={!part.productInformation.inStock && !part.productInformation.availableFrom}
                        >
                            <span>{part.productInformation.name}</span>
                            <ProductAvailabilityLabel
                                inStock={part.productInformation.inStock}
                                availableFrom={part.productInformation.availableFrom}
                                stockQuantity={part.productInformation.stockQuantity}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }),
);

export default SelectCarrier;
